import { z } from "zod";

export interface MobileUser {
  id: number;
  nombre: string;
  apellido: string;
  documento: string;
  cuit: string;
  mail: string;
  movil: string;
  idPersona: number;
  validaIdentidad: boolean;
  baja?: boolean
  motivoBaja?: string
  fechaBaja?: string
}

//Los nombres debería coincidir con el backend
export const userFilterSchema = z.object({
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  cuit: z.string().optional(),
  dni: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().optional(),
});
